import { Component, Input } from '@angular/core';
import { ComponentContext, ConfirmationOptions } from '../modal.model';

@Component({
  selector: 'gcc-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
  standalone: false
})
export class ConfirmModalComponent implements ComponentContext<ConfirmationOptions> {
  @Input() public title: string;
  @Input() public message: string | string[];
  @Input() public confirmButton: string;
  @Input() public cancelButton: string;

  @Input() public onAction: () => void;
  @Input() public onClose: () => void;

  public get messages(): string[] {
    return Array.isArray(this.message) ? this.message : [this.message];
  }
}
